import { render, staticRenderFns } from "./five.vue?vue&type=template&id=f73d0cfa&scoped=true&"
var script = {}
import style0 from "./five.vue?vue&type=style&index=0&id=f73d0cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73d0cfa",
  null
  
)

export default component.exports